import { ExtractMethods } from "@/lib/typeUtils";
import { FlowHookType } from "../tourPlayback/flow";
import { FinishTourHook } from "./finishTour";
import { LoadCheckpointHook } from "./loadCheckpoint";
import { FlowHookActionsFacade } from "../tourPlayback/facades";

export type FlowHook = FinishTourHook | LoadCheckpointHook;

export type FlowHookActions = ExtractMethods<FlowHookActionsFacade>;

export class FlowHookFactory {
  static create(flowHookType: FlowHookType | undefined, actions: FlowHookActions) {
    if (!flowHookType) {
      return undefined;
    }

    switch (flowHookType) {
      case "finishTour":
        return new FinishTourHook(actions);
      case "loadCheckpoint":
        return new LoadCheckpointHook(actions);
      default:
        throw new Error(`Unknown flow hook type: ${flowHookType}`);
    }
  }
}
